import { FC, useMemo } from 'react';

import { useRecoilValue, useSetRecoilState } from 'recoil';

import { bugoBrandListStateSelector } from '@shared/api/bugoBrand/bugoBrand.selector';
import { Button } from '@shared/components/Button';
import { Icon } from '@shared/components/icons';
import { simpleOpenAtomFamily } from '@shared/state/atom';
import { useParams } from 'react-router-dom';

import { AdminAgencyWorkerUpsertModal } from '../components/AdminAgencyWorkerUpsertModal';
import { AgencyWorkerTable } from '../components/AgencyWorkerTable';
import { useAdminTitleHook } from '../hooks/useAdminTitleHook';

//* 관리자용 팀장 관리페이지
const AdminBugoBrandAgencyWorkerPage: FC = function AdminBugoBrandAgencyWorkerPage() {
  useAdminTitleHook('상조 지도사관리');
  const { PlusSolid } = Icon();
  const { bugoBrandId } = useParams();
  const bugoBrandListState = useRecoilValue(bugoBrandListStateSelector);
  const adminAgencyWorkerCreateOpenId = `adminBugoBrandAgencyWorker-create-${bugoBrandId}`;
  const setCreateModalOpen = useSetRecoilState(
    simpleOpenAtomFamily(adminAgencyWorkerCreateOpenId),
  );
  const bugoBrand = useMemo(() => {
    if (bugoBrandListState.status === 'success' && bugoBrandListState.data) {
      const bugoBrandList = bugoBrandListState.data;
      return bugoBrandList.find((item) => {
        return item._id === bugoBrandId;
      });
    }
  }, [bugoBrandId, bugoBrandListState.data, bugoBrandListState.status]);

  //* 팀장 추가
  const adminAgencyCreateButton = useMemo(() => {
    if (bugoBrand) {
      return (
        <>
          <Button
            className="center-box gap-1 shadow-sm theme-bg-1"
            onClick={() => {
              setCreateModalOpen(true);
            }}
          >
            <PlusSolid className="wh-4" />
            <p>지도사 계정 생성</p>
          </Button>
          <AdminAgencyWorkerUpsertModal
            openId={adminAgencyWorkerCreateOpenId}
            bugoBrand={bugoBrand}
          />
        </>
      );
    }
  }, [PlusSolid, adminAgencyWorkerCreateOpenId, bugoBrand, setCreateModalOpen]);

  const adminAgencyWorkerTable = useMemo(() => {
    if (bugoBrand) {
      const workerList = bugoBrand.workers;
      return <AgencyWorkerTable workerList={workerList} bugoBrand={bugoBrand} />;
    }
  }, [bugoBrand]);

  return (
    <div className="space-y-4 p-4">
      <div className="flex items-center justify-between">
        <p className="pl-2 text-16 font-bold">{bugoBrand?.bugoAgency?.corpName}</p>
        {adminAgencyCreateButton}
      </div>
      <div>{adminAgencyWorkerTable}</div>
    </div>
  );
};

export default AdminBugoBrandAgencyWorkerPage;
